import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import LaptopIcon from "@mui/icons-material/Laptop";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import { useTranslation } from "react-i18next";
import { useCustomCover, DEVICE_MODES } from "../index";

export const DeviceModeToolbar: React.FC = () => {
  const { t } = useTranslation();
  const { deviceMode, onToggleDeviceMode } = useCustomCover();

  return (
    <Box display="flex" justifyContent="center">
      <Box>
        <ToggleButtonGroup
          value={deviceMode}
          exclusive
          onChange={onToggleDeviceMode}
          aria-label={t("platformCustomCovers.editor.deviceModeAria")}
          size="small"
        >
          <ToggleButton
            selected={deviceMode === DEVICE_MODES.mobile}
            value={DEVICE_MODES.mobile}
            aria-label={t("platformCustomCovers.editor.devicePhoneAria")}
          >
            <PhoneAndroidIcon />
          </ToggleButton>
          <ToggleButton
            selected={deviceMode === DEVICE_MODES.desktop}
            value={DEVICE_MODES.desktop}
            aria-label={t("platformCustomCovers.editor.deviceLaptopAria")}
          >
            <LaptopIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};
